import { render, staticRenderFns } from "./ProRecommend.vue?vue&type=template&id=6523d0fc&scoped=true&"
import script from "./ProRecommend.vue?vue&type=script&lang=ts&"
export * from "./ProRecommend.vue?vue&type=script&lang=ts&"
import style0 from "./ProRecommend.vue?vue&type=style&index=0&id=6523d0fc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6523d0fc",
  null
  
)

export default component.exports